import { axiosDS } from '@pp/axios'
import { urls } from 'Src/constants/Urls'
import { OrderModel } from 'Pages/orders_design'
import { serialize } from 'object-to-formdata'

async function backToChecking(id: number, data: { files_attributes: File[] }) {
	const formData = serialize({ data }, { allowEmptyArrays: true })
	const res = await axiosDS().patch<OrderModel>(
		urls.orders.backToChecking.replace(':id', id.toString()),
		formData
	)
	return res.data
}

export const unBlockRequestApi = {
	backToChecking,
}
